import React from "react";
import { HeartIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { personas } from "../data/landing";
const tones: Record<string, {
  bg: string;
  icon: string;
}> = {
  royal: {
    bg: "bg-royal-light",
    icon: "fill-royal text-royal"
  },
  sun: {
    bg: "bg-sun-light",
    icon: "fill-tangerine text-tangerine"
  },
  leaf: {
    bg: "bg-leaf-light",
    icon: "fill-leaf text-leaf"
  },
  rosy: {
    bg: "bg-rosy-light",
    icon: "fill-rosy text-rosy"
  }
};
export function PersonaSection() {
  return <section className="bg-ivory" data-id="element-202" data-mp="14mcv17xhvez2">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-24" data-id="element-203" data-mp="14ml5yua24a7m">
        <SectionHeading title="Ce Méga Pack est fait pour vous si…" data-id="element-204" data-mp="qmjwwrjn1wh2" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 md:gap-5" data-id="element-205" data-mp="vmg2gv7zhvyq">
          {personas.map(p => <li key={p.text} className={`flex gap-4 rounded-[2rem] px-6 py-7 md:px-8 md:py-8 ${tones[p.tone].bg}`} data-id="element-206" data-mp="3be3v4efyt2bq">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white" data-id="element-207" data-mp="3ge8fifjzuh78">
                <HeartIcon className={`h-5 w-5 ${tones[p.tone].icon}`} aria-hidden="true" data-id="element-208" data-mp="1sn4jzgwnqdzg" />
              </span>
              <p className="font-display text-lg font-semibold leading-snug text-royal-deep md:text-xl" data-id="element-209" data-mp="1olsz1ooqagxl">
                {p.text}
              </p>
            </li>)}
        </ul>

        <p className="mt-8 text-center text-sm font-semibold text-cocoa-soft md:text-base" data-id="element-210" data-mp="1xm7matl9663q">
          Une ressource également utile pour les grands-parents et les éducateurs chrétiens.
        </p>
      </div>
    </section>;
}